import React from 'react';

import { AspectRatio, Box, Stack, createStyles, useMantineTheme } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { ErrorAlert } from 'components/ErrorAlert';
import { FullScreenLoader } from 'components/FullScreenLoader';
import { ResourceViewerWrapper } from 'components/ResourceViewerWrapper/ResourceViewerWrapper';
import ReactPlayer from 'react-player';
import { useParams } from 'react-router';
import { ResourceService } from 'services/resource-service';
import { DOWNLOAD_FILE_QUERY_KEY, RESOURCE_QUERY_KEY } from 'shared/constants/query-keys';

const useStyles = createStyles(() => ({
  videoPlayer: {
    borderRadius: 20,
    overflow: 'hidden'
  },
  aspectRatioContainer: {
    width: '100%',
    maxWidth: 900
  }
}));

export function VideoViewerPage() {
  const theme = useMantineTheme();
  const { resourceId } = useParams();
  const { classes } = useStyles();

  if (!resourceId) return <ErrorAlert />;

  const fileQuery = useQuery({
    queryKey: [DOWNLOAD_FILE_QUERY_KEY, { resourceId }],
    queryFn: () => ResourceService.getVideoSignedUrl(resourceId),
    refetchOnWindowFocus: false
  });

  const resourceQuery = useQuery({
    queryKey: [RESOURCE_QUERY_KEY, { resourceId }],
    queryFn: () => ResourceService.getResourceInfo(resourceId),
    refetchOnWindowFocus: false
  });

  if (fileQuery.isLoading || resourceQuery.isLoading || !fileQuery.data || !resourceQuery.data)
    return <FullScreenLoader />;
  if (fileQuery.isError || resourceQuery.isError) return <ErrorAlert />;

  return (
    <ResourceViewerWrapper
      resourceId={resourceId}
      fileName={resourceQuery.data.fileName}
      backgroundColor={theme.colors.gray[0]}>
      <Stack justify="center" align="center" p={48} style={{ flex: 1, width: '100%' }}>
        <Box className={classes.aspectRatioContainer}>
          <AspectRatio ratio={16 / 9}>
            <ReactPlayer
              url={fileQuery.data}
              className={classes.videoPlayer}
              width="100%"
              height="100%"
              controls
              config={{
                file: {
                  attributes: {
                    type: 'video/mp4'
                  }
                }
              }}
            />
          </AspectRatio>
        </Box>
      </Stack>
    </ResourceViewerWrapper>
  );
}
